/**
 * Valores hex de la paleta de marca GFI Latino.
 * Deben mantenerse sincronizados con las variables CSS en index.css.
 * Usados en datos mock con colores dinámicos (ej. gráficos de reconocimiento).
 */
export const BRAND_COLORS = {
  cyan: '#3FA9D6',
  green: '#4FBF8F',
  gold: '#F2C230',
  goldDark: '#D4A017',
  navy: '#1B2A5E',
  cream: '#F5F3EC',
  night: '#0E1733',
};

/** Lockup horizontal oficial — variante según fondo claro u oscuro */
export const BRAND_LOGO = {
  light: 'https://media.publit.io/file/GFILATINO/GFILatino-SVG1.svg',
  dark: 'https://media.publit.io/file/GFILATINO/GFILatino-nightSVG1.svg',
};
